import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("企业信息")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("企业账户")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("个体工商户")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("小微商户")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("机关事业单位或社会团体")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("民办非企业")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("有固定营业场所")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("无固定营业场所")
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传经营场所门头照片图片", -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传经营场所室内照片图片", -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, " 请上传营业执照/组织机构代码证图片 ", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("法人及控股股东信息")
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传法人身份证人像面图片", -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传法人身份证国徽面图片", -1)
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传法人手持证据照图片", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("未知")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("结算信息")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("公司账户")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("个人账户")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("开通")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("不开通")
const _hoisted_37 = ["src"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "请上传结算证明材料", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("发展人信息")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "新建银联签约账户" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onSubmit('formRef')))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          name: "basic",
          rules: $setup.rules,
          "label-col": { span: 3 },
          "wrapper-col": { span: 13 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "注册类型",
              name: "reg_mer_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.reg_mer_type,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.reg_mer_type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "00" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "01" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "02" }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "03" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "05" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "是否有营业场所",
              name: "having_fixed_busi_addr"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.having_fixed_busi_addr,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.having_fixed_busi_addr) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "a" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "b" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "营业场所图片",
              name: "pictures"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  ref: "stroe",
                  "v-model:file-list": $setup.pictures.stroe ? [] : [$setup.pictures.stroe],
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0005', picture_field: 'stroe' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.stroe)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.stroe,
                          alt: "经营场所门头照片",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_10))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_12
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"]),
                _createVNode(_component_a_upload, {
                  style: {"margin-left":"200px !important"},
                  ref: "stroe_inner",
                  "v-model:file-list": 
              $setup.pictures.stroe_inner ? [] : [$setup.pictures.stroe_inner]
            ,
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0015', picture_field: 'stroe_inner' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.stroe_inner)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.stroe_inner,
                          alt: "经营场所室内照片",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_13))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_15
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.formState.reg_mer_type != '05')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "商户营业执照",
                  name: "pictures"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_upload, {
                      ref: "shop_lic",
                      "v-model:file-list": $setup.pictures.shop_lic ? [] : [$setup.pictures.shop_lic],
                      name: "picture",
                      "list-type": "picture-card",
                      class: "avatar-uploader",
                      data: { document_type: '0002', picture_field: 'shop_lic' },
                      "show-upload-list": false,
                      action: $setup.chinaumsPicUploadUrl,
                      "before-upload": _ctx.beforeUpload,
                      onChange: $setup.handleChange
                    }, {
                      default: _withCtx(() => [
                        ($setup.pictures.shop_lic)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: $setup.pictures.shop_lic,
                              alt: "营业执照图片",
                              style: {"width":"90px","height":"90px"}
                            }, null, 8, _hoisted_16))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_ctx.loading)
                                ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                              _hoisted_18
                            ]))
                      ]),
                      _: 1
                    }, 8, ["v-model:file-list", "action", "before-upload", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "商户营业名称",
              name: "shop_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.shop_name,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.shop_name) = $event)),
                  placeholder: "请输入商户营业名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.formState.reg_mer_type !== '02')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "社会信用统一代码",
                  name: "shop_lic"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.shop_lic,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.shop_lic) = $event)),
                      placeholder: "请输入社会信用统一代码"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formState.reg_mer_type == '02')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "社会信用统一代码",
                  name: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.shop_lic,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.shop_lic) = $event)),
                      placeholder: "请输入社会信用统一代码"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "商户营业地址",
              name: "shop_region_ids"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_cascader, {
                  style: {"width":"360px"},
                  ref: "shopRegionCascader",
                  value: _ctx.formState.shop_region_ids,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.shop_region_ids) = $event)),
                  "show-search": { filter: _ctx.filter },
                  options: $setup.regionList,
                  placeholder: "请输入营业区域进行选择",
                  onChange: $setup.handleShopRegionChange
                }, null, 8, ["value", "show-search", "options", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "商户详细地址",
              name: "shop_addr_ext"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.shop_addr_ext,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.shop_addr_ext) = $event)),
                  placeholder: "商户详细地址，如xxx街道xxx号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人证件信息",
              name: "pictures"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "v-model:file-list": 
              $setup.pictures.id_card_front ? [] : [$setup.pictures.id_card_front]
            ,
                  ref: "idCardFront",
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0001', picture_field: 'id_card_front' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.id_card_front)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.id_card_front,
                          alt: "法人身份证人像面图片",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_20))
                      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_22
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"]),
                _createVNode(_component_a_upload, {
                  "v-model:file-list": 
              $setup.pictures.id_card_back ? [] : [$setup.pictures.id_card_back]
            ,
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0011', picture_field: 'id_card_back' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.id_card_back)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.id_card_back,
                          alt: "法人身份证国徽面图片",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_25
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"]),
                _createVNode(_component_a_upload, {
                  "v-model:file-list": 
              $setup.pictures.id_card_handle ? [] : [$setup.pictures.id_card_handle]
            ,
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0007', picture_field: 'id_card_handle' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.id_card_handle)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.id_card_handle,
                          alt: "法人手持证据照",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_26))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_28
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人姓名",
              name: "legal_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.legal_name,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.legal_name) = $event)),
                  placeholder: "请输入法人姓名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人手机号",
              name: "legal_mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.legal_mobile,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.legal_mobile) = $event)),
                  placeholder: "请输入法人手机号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人身份证号",
              name: "legal_idcard_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.legal_idcard_no,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.legal_idcard_no) = $event)),
                  placeholder: "请输入法人身份证号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人证件截止日期",
              name: "legal_card_deadline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  style: {"width":"200px"},
                  value: _ctx.formState.legal_card_deadline,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.legal_card_deadline) = $event)),
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请输入法人证件截止日期"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人家庭地址",
              name: "legalmanHomeAddr"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.legalmanHomeAddr,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.legalmanHomeAddr) = $event)),
                  placeholder: "请输入法人家庭地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人性别",
              name: "legal_sex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  style: {"width":"360px"},
                  value: _ctx.formState.legal_sex,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.legal_sex) = $event)),
                  placeholder: "请选择法人性别"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "法人职业",
              name: "legal_occupation"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.legal_occupation,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.legal_occupation) = $event)),
                  style: {"width":"360px"},
                  placeholder: "请选择法人职业"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.occupationList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.formState.legal_occupation == '7')
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 3,
                  label: "法人职业详细描述",
                  name: "legalmanCareerDesc"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formState.legalmanCareerDesc,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.legalmanCareerDesc) = $event)),
                      placeholder: "请输入法人职业详细描述"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "法人邮箱",
              name: "legal_email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.legal_email,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.legal_email) = $event)),
                  placeholder: "请输入法人邮箱"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "控股股东姓名",
              name: "shareholderName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.shareholderName,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formState.shareholderName) = $event)),
                  placeholder: "商户类型为非小微，且控股股东非法人时必填"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "控股股东证件类型",
              name: "shareholderCertType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.shareholderCertType,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formState.shareholderCertType) = $event)),
                  style: {"width":"360px"},
                  placeholder: "请选择控股股东证件证件类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.shareholderCertTypeList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "控股股东证件号",
              name: "shareholderCertno"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.shareholderCertno,
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formState.shareholderCertno) = $event)),
                  placeholder: "请输入控股股东证件号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "控股股东证件有效期",
              name: "shareholderCertExpire"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  style: {"width":"200px"},
                  value: _ctx.formState.shareholderCertExpire,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formState.shareholderCertExpire) = $event)),
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "控股股东家庭地址",
              name: "shareholderHomeAddr"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.shareholderHomeAddr,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formState.shareholderHomeAddr) = $event)),
                  placeholder: "请输入控股股东家庭地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "受益人列表",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.username,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formState.username) = $event)),
                  placeholder: "请输入控股股东家庭地址"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _hoisted_32
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "账户类型",
              name: "bank_acct_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.bank_acct_type,
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formState.bank_acct_type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_34
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开通资管系统",
              name: "join_eam"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.join_eam,
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formState.join_eam) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_35
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "0" }, {
                      default: _withCtx(() => [
                        _hoisted_36
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "结算证明材料",
              name: "pictures"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  ref: "bank_lic",
                  "v-model:file-list": $setup.pictures.bank_lic ? [] : [$setup.pictures.bank_lic],
                  name: "picture",
                  "list-type": "picture-card",
                  class: "avatar-uploader",
                  data: { document_type: '0006', picture_field: 'bank_lic' },
                  "show-upload-list": false,
                  action: $setup.chinaumsPicUploadUrl,
                  "before-upload": _ctx.beforeUpload,
                  onChange: $setup.handleChange
                }, {
                  default: _withCtx(() => [
                    ($setup.pictures.bank_lic)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: $setup.pictures.bank_lic,
                          alt: "结算证明材料",
                          style: {"width":"90px","height":"90px"}
                        }, null, 8, _hoisted_37))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                          _hoisted_39
                        ]))
                  ]),
                  _: 1
                }, 8, ["v-model:file-list", "action", "before-upload", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开户行所属区域",
              name: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_cascader, {
                  style: {"width":"360px"},
                  ref: "bankRegionCascader",
                  value: _ctx.formState.bankRegion,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formState.bankRegion) = $event)),
                  "show-search": { filter: _ctx.filter },
                  options: $setup.regionList,
                  placeholder: "请输入营业区域进行选择",
                  onChange: _ctx.handelBankRegionChange
                }, null, 8, ["value", "show-search", "options", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开户支行名称",
              name: "bank_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.bank_no,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formState.bank_no) = $event)),
                  placeholder: "请输入开户支行名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开户账号名称",
              name: "bank_acct_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.bank_acct_name,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formState.bank_acct_name) = $event)),
                  placeholder: "请输入开户账号名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开户行账号",
              name: "bank_acct_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.bank_acct_no,
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formState.bank_acct_no) = $event)),
                  placeholder: "请输入开户行账号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_divider, { orientation: "left" }, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "发展部门",
              name: "developingDept"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.developingDept,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formState.developingDept) = $event)),
                  placeholder: "请输入发展部门"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "发展人",
              name: "developingPersonID"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.developingPersonID,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formState.developingPersonID) = $event)),
                  placeholder: "请输入发展人"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
}